import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import moment from 'moment';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

import styles from './styles';

import TaskProfileDrilldown from '../TaskProfileDrilldown';
import ReduxDialog from '../Common/ReduxDialog';
import { fetchTaskFileConfigs } from '../../actions/taskfileconfigs';
import { fetchItemTypes } from '../../actions/itemtypes';
import { hideDialog, showError } from '../../actions/dialogs';
import { uploadTasks } from '../../actions/tasks';
import { fetchTaskProfiles } from '../../actions/taskprofiles';
import { parseTasks } from '../../utils/csv';
import { id } from '../../utils/helper';

class TaskUploadDialog extends Component {
  static propTypes = {
    job: PropTypes.object.isRequired,
    fetchTaskFileConfigs: PropTypes.func.isRequired,
    fetchTaskProfiles: PropTypes.func.isRequired,
    fetchItemTypes: PropTypes.func.isRequired,
    itemTypes: PropTypes.object.isRequired,

    uploadTasks: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    taskFileConfigs: PropTypes.array.isRequired,
    taskProfiles: PropTypes.array.isRequired,

    hideDialog: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
  };

  state = {
    finished: false,
    stepIndex: 0,
    fileConfig: null,
  };

  componentWillMount() {
    this.props.fetchTaskFileConfigs();
    this.props.fetchTaskProfiles();
    this.props.fetchItemTypes();
  }

  handleNext = () => {
    const { stepIndex, fileConfig, file, taskProfile } = this.state;

    console.log('fileConfig', fileConfig, stepIndex);
    switch (stepIndex) {
      case 0:
        if (!fileConfig) {
          this.props.showError('Invalid Options', 'Please select a file format');
          return;
        }

        if (!file) {
          this.props.showError('Invalid Options', 'Please select a task list file');
          return;
        }

        break;
      case 1:
        if (!taskProfile) {
          this.props.showError('Invalid Options', 'Please select a task profile');
          return;
        }
        break;
      default :
        break;
    }

    if (stepIndex === 1) {
      this.handleUpload();
    }

    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= 1,
    });
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  handleSelectTaskProfile = (taskProfiles) => {
    console.log('handleSelectTaskProfile', taskProfiles);
    this.setState({ taskProfile: taskProfiles[0] });
  };

  getStepContent(stepIndex) {
    console.log('stepIndex', stepIndex);
    switch (stepIndex) {
      case 0:
        return (<div>
          <div>
            <SelectField
              floatingLabelFixed
              floatingLabelText="File Format"
              value={this.state.fileConfig}
              onChange={(event, index, fileConfig) => this.setState({ fileConfig, })}
              fullWidth
            >
              { (this.props.taskFileConfigs || []).map((fileConfig) => <MenuItem
                key={fileConfig.id}
                value={fileConfig}
                primaryText={fileConfig.name}
              />)}
            </SelectField>
          </div>

          { this.state.fileConfig ? this.renderDropZone() : null }
        </div>);
      case 1:
        return <div>
          {/*<SelectField*/}
          {/*floatingLabelFixed*/}
          {/*floatingLabelText="Task Profile"*/}
          {/*value={this.state.taskProfile}*/}
          {/*onChange={(event, index, taskProfile) => this.setState({ taskProfile, })}*/}
          {/*fullWidth*/}
          {/*>*/}
          {/*<MenuItem*/}
          {/*key={0}*/}
          {/*value={{}}*/}
          {/*primaryText={'None'}*/}
          {/*/>*/}
          {/*{ (this.props.taskProfiles || []).map((taskProfile) => <MenuItem*/}
          {/*key={taskProfile.id}*/}
          {/*value={taskProfile}*/}
          {/*primaryText={taskProfile.name}*/}
          {/*/>)}*/}
          {/*</SelectField>*/}
          <TaskProfileDrilldown
            availableTaskProfiles={this.props.taskProfiles}
            taskProfiles={this.state.taskProfile ? [this.state.taskProfile] : []}
            onChange={this.handleSelectTaskProfile}
            selectable={false}
          />
        </div>;
      default:
        return 'You\'re a long way from home sonny jim!';
    }
  }

  handleCancel = () => {
    // this.props.onRequestClose();
    this.props.hideDialog('taskUpload');
  };

  handleUpload = () => {
    const tasks = this.state.tasks.map((task) => {
      return _.assign({}, task, {
        items: _.keys(this.state.taskProfile.itemTypes).reduce((res, itemTypeId) => {
          _.range(this.state.taskProfile.itemTypes[itemTypeId]).forEach(() => {
            const i = id();
            res[i] = {
              // id: i,
              type: this.props.itemTypes[itemTypeId],
            };
          });

          return res;
        }, {}),
      });
    });
    // const items = ;

    // const taskProfile = _.assign({}, this.state.taskProfile, {items});
    this.props.uploadTasks(this.props.job, tasks);
    this.props.hideDialog('taskUpload');
  };

  handleFileSelection = (files) => {
    const { showError } = this.props;
    const file = files[0];
    this.setState({
        file,
        uploading: true,
      }, () => {
        const reader = new FileReader();
        const dialog = this;

        reader.addEventListener('load', () => {
          return parseTasks(reader.result, this.state.fileConfig).then((data) => {
            const task = data.length > 0 ? data[0] : {};
            const headings = _.keys(task);
            console.log('headings', headings);

            dialog.setState({
              rawData: reader.result,
              tasks: data,
              // headings,
              // fieldMappings,
              uploading: false,
            });

            // this.props.onUpload({
            //   rawData: reader.result,
            //   tasks: data,
            // });
          }).catch((err) => {
            console.error(err);
            dialog.setState({
              uploading: false,
              uploadResult: 'Unable to process CSV file',
            });
          });
        }, false);

        reader.addEventListener('error', (err) => {
          console.error('onerror', err);
          showError('Upload Error', 'Unable to process file');
          dialog.setState({
            uploading: false,
          });
        });

        if (file) {
          reader.readAsText(file);
        } else {
          console.log('no file');
        }
      }
    );
  };

  renderCsvDetails() {
    if (this.state.file && !this.state.uploading) {
      return (<div style={styles.csvInfo}>
        <div style={styles.csvProperties}>
          <div><b>Name:</b> { this.state.file.name }</div>
          <div><b>Modified:</b> { moment(this.state.file.lastModified).format('lll') }</div>
          <div><b>Size:</b> { Math.round(this.state.file.size / 10.24) / 100 }kb</div>
        </div>
        <div style={styles.tasksInfo}>
          <div>Tasks</div>
          <div style={styles.taskCount}>{this.state.tasks.length}</div>
        </div>
      </div>);
    }

    return null;
  }

  renderDropZone() {
    return (<Dropzone
      style={styles.dropzone}
      activeStyle={styles.dropzoneActive}
      onDrop={this.handleFileSelection}
      multiple={false}
    >
      <div style={styles.csv}>
        <div style={styles.uploadInstructions}>
          <div>Drag a CSV file onto here</div>
          <img alt="CSV" src="/images/csv-64.png"/>
          <div>or click to select a file</div>
        </div>

        { this.state.uploading ? <div>Uploading...</div> : this.renderCsvDetails() }
      </div>
    </Dropzone>);
  }

  render() {
    const { stepIndex } = this.state;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('taskUpload')}
      />,
      <FlatButton
        label="Back"
        disabled={stepIndex === 0}
        onClick={this.handlePrev}
        style={{ marginRight: 12 }}
      />,
      <FlatButton
        label={stepIndex === 1 ? 'Upload' : 'Next'}
        primary
        onClick={this.handleNext}
      />,
    ];

    return (
      <div>
        <ReduxDialog
          name="taskUpload"
          title="Upload Tasks"
          actions={actions}
          modal
          bodyStyle={styles.body}
        >
          <div style={styles.container}>
            <Stepper activeStep={stepIndex}>
              <Step>
                <StepLabel>Upload Tasks</StepLabel>
              </Step>
              <Step>
                <StepLabel>Select Task Profile</StepLabel>
              </Step>
            </Stepper>

            {this.getStepContent(this.state.stepIndex)}
          </div>
        </ReduxDialog>
      </div>
    );
  }
}

const form = reduxForm({
  form: 'TaskUpload',  // a unique identifier for this form
  // validate,
  // asyncValidate
  enableReinitialize: true,
})(TaskUploadDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskFileConfigs,
    fetchTaskProfiles,
    fetchItemTypes,
    uploadTasks,
    hideDialog,
    showError,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    job: state.get('jobs').get('job').toJS(),
    taskFileConfigs: state.get('taskFileConfigs').get('taskfileconfigs').toJS(),
    taskProfiles: state.get('taskprofiles').get('taskProfiles').toJS(),
    itemTypes: state.get('itemtypes').get('itemTypes').toJS(),
    loading: state.get('taskFileConfigs').get('loading'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/TaskUploadDialog/index.js